import React, { useState } from "react";
import { DatePicker, Table } from "antd";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { useTableSearch } from "core/Operations/useTableSearch";
import Error404 from "MainPages/ErrorPages/error404";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { PlusCircle } from "react-feather";
import { Link } from "react-router-dom";
import { all_routes } from "Router/all_routes";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import TableTop from "Components/UI/TableTop";
import { endOfMonth, format, startOfMonth } from "date-fns";
import dayjs from "dayjs";
import { useGetEmployeeQuery } from "AppQuries/employee/employee_list";
import Select from "react-select";
import ReportTools from "Components/UI/ReportTools";
import { useLeaveReportQuery } from "AppQuries/report/get-leave-report";
import { BackIcon } from "Components/UI/Icon/Icons";
const { RangePicker } = DatePicker;
const LeaveReport = () => {
  const userData = useSelector(loggedInUser);

  const [queryParams, setQueryParams] = useState({
    fromDate: format(startOfMonth(new Date(), 1), "yyyy-MM-dd"),
    toDate: format(endOfMonth(new Date(), 1), "yyyy-MM-dd"),
    employeeCode: 0,
  });

  const {
    data,
    isFetching,
    isError,
    error,
    refetch: getReport,
  } = useLeaveReportQuery(
    {
      companyCode: userData?.companyCode,
      locationCode: userData?.selectedLocationCode,
      userId: userData?.userID,
      isAllCompanies: userData?.isAllCompanies,
      selectedCompanyCode: userData?.selectedCompanyCode,
      ...queryParams,
    },
    {
      enabled: !!queryParams?.fromDate && !!queryParams?.toDate,
    }
  );

  const reportData = data?.map((d, _id) => ({
    ...d,
    id: _id + 1,
    requestDate: format(new Date(d?.requestDate), "dd-MM-yyyy"),
    leaveFrom: format(new Date(d?.leaveFrom), "dd-MM-yyyy"),
    leaveTo: format(new Date(d?.leaveTo), "dd-MM-yyyy"),
    approvedDate:
      d.approvedDate !== null
        ? format(new Date(d.approvedDate), "dd-MM-yyyy")
        : "",
    isApproved:
      d.isApproved === 0
        ? "Pending"
        : d.isApproved === 1
        ? "Approved"
        : "Rejected",
  }));

  const { data: employees } = useGetEmployeeQuery({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
  });

  const employeeOptions =
    employees
      ?.filter((d) => d.isActive)
      .map((o) => ({
        id: o.employeeCode,
        label: `${o.uniqueId}-${o.fullName}`,
        value: o.employeeCode,
      })) || [];
  const [isFilterVisible, setIsFilterVisible] = useState(true);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const updateQueryParams = (key, value) => {
    setQueryParams((prev) => ({ ...prev, [key]: value }));
  };

  const columns = [
    {
      title: "Emp Code",
      dataIndex: "uniqueID",
      sorter: (a, b) => a.uniqueID - b.uniqueID,
    },
    {
      title: "Employee Name",
      dataIndex: "employeeName",
      sorter: (a, b) => a.employeeName.length - b.employeeName.length,
    },
    {
      title: "Request Date",
      dataIndex: "requestDate",
      // render: (text, record) => (
      //   <div>{format(new Date(text), "dd-MM-yyyy")}</div>
      // ),
      sorter: (a, b) => a.requestDate.length - b.requestDate.length,
    },
    {
      title: "Leave From",
      dataIndex: "leaveFrom",
      // render: (text, record) => (
      //   <div>{format(new Date(text), "dd-MM-yyyy")}</div>
      // ),
      sorter: (a, b) => a.leaveFrom.length - b.leaveFrom.length,
    },
    {
      title: "Leave To",
      dataIndex: "leaveTo",
      // render: (text, record) => (
      //   <div>{format(new Date(text), "dd-MM-yyyy")}</div>
      // ),
      sorter: (a, b) => a.leaveTo.length - b.leaveTo.length,
    },

    {
      title: "No Of Days",
      dataIndex: "noOfDays",
      sorter: (a, b) => a.noOfDays.length - b.noOfDays.length,
    },
    {
      title: "Reason",
      dataIndex: "reason",
      sorter: (a, b) => a.reason.length - b.reason.length,
    },
    {
      title: "Status",
      dataIndex: "isApproved",
      // render: (text, record) => (
      //   <>
      //     {text === 0 && <div className="">Pending</div>}
      //     {text === 1 && <div className="">Approved</div>}
      //     {text === 2 && <div className="">Rejected</div>}
      //   </>
      // ),
      // sorter: (a, b) => a.isApproved.length - b.isApproved.length,
    },
    {
      title: "Approved By",
      dataIndex: "approvedBy",
      sorter: (a, b) => a.approvedBy.length - b.approvedBy.length,
    },
    {
      title: "Approved Date",
      dataIndex: "approvedDate",
      // render: (text, record) => (
      //   <div>
      //     {record.approvedDate === ""
      //       ? ""
      //       : format(new Date(text), "dd-MM-yyyy")}
      //   </div>
      // ),
    },
  ];

  const searchColumns = columns.map((column, index) => column.dataIndex);
  const { searchValue, setSearchValue, filteredData } = useTableSearch(
    reportData,
    searchColumns
  );
  if (isFetching) return <LoadingSpinner />;
  if (isError) return <Error404 error={error} />;
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Leave Report</h4>
              <h6>View Employee Leave Progress</h6>
            </div>
          </div>
          <ReportTools
            columns={columns}
            data={reportData}
            fileName={`Leave Report ${queryParams.fromDate} - ${queryParams.toDate}`}
            pdfTheme="striped"
            refresh={getReport}
          />
          <div className="page-btn">
            <Link
              to={`${all_routes.report_list}`}
              f
              className="btn btn-secondary"
            >
              <BackIcon className="me-2" />
              Back
            </Link>
          </div>
        </div>

        <div className="card table-list-card border-0">
          <div className="card-body">
            <TableTop
              onSearch={setSearchValue}
              toggleFilterVisibility={toggleFilterVisibility}
              isFilterVisible={isFilterVisible}
              showToggle={true}
            />
            <div
              className={`card${isFilterVisible ? " visible" : ""}`}
              id="filter_inputs"
              // style={{ display: isFilterVisible ? "block" : "none" }}
            >
              
              <div className="card-body pb-0">
                <div className="form-row row">
                  <div className="row">
                    <div className="col-lg-3 col-sm-6 col-12 mb-3">
                      <label className="form-label">
                        Start Date – End Date
                      </label>
                      <div className="form-group">
                        <RangePicker
                          className="form-control"
                          style={{ display: "flex" }}
                          onChange={(dates, dateStrings) => {
                            if (dates) {
                              updateQueryParams("fromDate", dateStrings[0]);
                              updateQueryParams("toDate", dateStrings[1]);
                            }
                          }}
                          defaultValue={[
                            dayjs(queryParams.fromDate, "YYYY-MM-DD"),
                            dayjs(queryParams.toDate, "YYYY-MM-DD"),
                          ]}
                          dateFormat="YYYY-MM-DD"
                          getPopupContainer={(triggerNode) =>
                            triggerNode.parentNode
                          }
                          // disabledDate={disabledDate}
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12 mb-3">
                      <div className="form-group">
                        <label className="form-label">Employee </label>

                        <Select
                          className="select"
                          options={employeeOptions}
                          placeholder="Employee"
                          value={employeeOptions.find(
                            (option) =>
                              option.value === queryParams?.employeeCode
                          )}
                          onChange={(e) => {
                            updateQueryParams("employeeCode", e?.value || 0);
                          }}
                          isClearable
                          //   styles={{
                          //     control: (baseStyles, state) => ({
                          //       ...baseStyles,
                          //       fontSize: "12px",
                          //       width: "100px",
                          //     }),
                          //   }}
                        />
                      </div>
                    </div>

                    <div className="col-lg-3 col-sm-6 col-12">
                      <div className="input-blocks">
                        <label className="form-label">&nbsp;</label>
                        <Link
                          className="btn btn-filters ms-auto"
                          onClick={getReport}
                          type="button"
                        >
                          <i data-feather="search" className="feather-search" />
                          {isFetching ? (
                            <>
                              <i className="fas fa-spinner fa-spin me-2"></i>
                              Loading...
                            </>
                          ) : (
                            <>Filter</>
                          )}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <Table
                className="table  datanew"
                columns={columns}
                dataSource={filteredData}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaveReport;
